import React from "react";
import { Link } from "react-router-dom";

import * as C from "./styles";

const Page404 = () => {
  return (
    <C.Container>
      <div className="message">
          <h1>404</h1>
          <h3>A página que você está procurando não existe!</h3>
          <Link to="/"> Voltar para o início</Link>
      </div>
    </C.Container>
  );
}

export default Page404;